var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "language-dropdown",
      attrs: {
        "aria-role": "list",
        "mobile-modal": false,
        disabled: !_vm.hasLanguages,
        position: _vm.position,
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "button is-cancel is-outlined",
          class: { disabled: !_vm.hasLanguages },
          attrs: { slot: "trigger" },
          slot: "trigger",
        },
        [
          _c(
            "span",
            { staticClass: "icon is-small hideOnCollapse" },
            [_c("font-awesome-icon", { attrs: { icon: ["fas", "globe"] } })],
            1
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.value ? _vm.value.toUpperCase() : "") +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _vm.hasLanguages
            ? _c(
                "span",
                { staticClass: "icon is-small hideOnCollapse" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "angle-down"] },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.languages, function (language, index) {
        return _c(
          "b-dropdown-item",
          {
            key: `lang_${index}`,
            attrs: { "has-link": "", "aria-role": "listitem" },
          },
          [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onLanguage(language.id)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(language.id.toUpperCase()) +
                    " -\n            " +
                    _vm._s(language.name) +
                    "\n        "
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }